<template>
  <div class="page_bg" style="margin:0;">
    <div class="tagIdProList_top2">
      <div class="flex-r-sb-c">
        <div style="margin-left: 0.4rem;">
          <van-icon name="arrow-left" size="0.6rem" style="font-weight: 700;" @click="backPath" />
          <van-image width="2.24rem" height="0.64rem" :src="require('../../assets/serTitle04.png')" />
        </div>
        <div class="top_icon" style="margin-right: 0.4rem;" @click="$router.push('/cart/cart')">
          <van-badge :content="$store.getters.totalShopping">
            <div style="height: 0.7rem;line-height: 0.7rem;">
              <van-icon name="shopping-cart-o" size="0.6rem" />
            </div>
          </van-badge>
        </div>
      </div>
      <div class="tagIdProList_ser  flex-c-s-c">
        <div class="ser_search  flex-r-sb-c">
          <van-search v-model="searchValue" class="classify_ser" placeholder="请输入商品名称" shape="round" @search="inputSer"
                      @focus="onFocus"
          />
        </div>
      </div>
      <div style="position: relative;">
        <!-- 顶部过滤 -->
        <serTopFilter ref="serTopFilter" :type="3" :mid="$route.query.id" @changeFilter="changeFilter"
                      @changeFiltercategory="changeFiltercategory" @changeFilterbrand="changeFilterbrand"
        />
        <!-- 商品列表区域  -->
        <div class="pro_list">
          <MyscrollList ref="myList01" :loading="listLoading" :list="proList" @myload="proload">
            <template #default="slotProps">
              <proCard09 :info="slotProps.item" :type="type" @addCart="toCart" />
            </template>
          </MyscrollList>
        </div>
      </div>
    </div>
    <!-- spu -->
    <spuDrawer v-if="showSpu" ref="spuDrawer" source="list" :info="proDetailInfo" :pro-id="pid"
               :spu-level01-id="firstLevelTagId" :spu-level02-id="secondLevelTagId" @loadPro="loadPro"
               @closespu="closePopup"
    />
  </div>
</template>

<script>
import { productModule_productList } from '@/api/home'
import { ProductListspu } from '@/api/cart'
import MyscrollList from '@/components/MyscrollList'
import proCard09 from '@/components/pro_card_09'
import serTopFilter from '@/components/ser_top_filter'
import spuDrawer from '@/components/spuDrawer'
export default {
  components: { MyscrollList, proCard09, serTopFilter, spuDrawer },
  data() {
    return {
      type: '0',
      // 商品列表
      proSearch: { page: 1, limit: 10, mallProductModuleId: '' },
      proList: [],
      listLoading: false,

      showSpu: false,
      pid: 0,
      proDetailInfo: {},
      firstLevelTagId: null,
      secondLevelTagId: null
    }
  },
  created() {
    this.proSearch.mallProductModuleId = this.$route.query.id
    this.type = this.$route.query.type
    this.getProList()
  },
  activated() {
    console.log('keepalive 进入activerProList')
    if (sessionStorage.getItem('listJump')) {
      window.scrollTo({
        top: 0, // 滚动到顶部
        behavior: 'smooth' // 平滑滚动
      })
      sessionStorage.removeItem('listJump')
      this.proSearch.proBrand = this.$route.query.id
      this.getProList()
    }
  },
  deactivated() {
    this.$refs.serTopFilter.closePullBox()
    console.log('keepalive 离开activerProList')
  },
  methods: {
    backPath() { window.history.back() },
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      productModule_productList(this.proSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    },

    // 顶部搜索
    changeFilter(e) {
      console.log(e)
      this.$refs.myList01.load_status_clear()
      this.proSearch.page = 1
      this.proSearch.mallProductModuleId = this.$route.query.id
      if (e === 1 || e === 41) {
        this.proSearch.orderType = ''
        this.proSearch.orderWay = ''
        this.proSearch.tagId = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
      }
      if (e === 2) {
        this.issaleNum = !this.issaleNum
        this.proSearch.orderType = 'SALE_NUM'
        this.proSearch.orderWay = this.issaleNum ? 'DESC' : 'ASC'
        this.proSearch.tagId = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
      }
      if (e === 3) {
        this.isprice = !this.isprice
        this.proSearch.orderType = 'PRICE'
        this.proSearch.orderWay = this.isprice ? 'DESC' : 'ASC'
        this.proSearch.tagId = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
      }
      if (e === 42) {
        this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
        this.proSearch.tagId = '282'
      }
      if (e === 43) {
        this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
        this.proSearch.tagId = '281'
      }
      if (e === 44) {
        this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.proBrand = ''; this.proSearch.proCategoryId = ''
        this.proSearch.tagId = '275'
      }
      this.proList = []
      this.getProList()
    },
    changeFiltercategory(id) {
      this.$refs.myList01.load_status_clear()
      this.proSearch.page = 1
      this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.proBrand = ''
      this.proSearch.tagId = ''; this.proSearch.proCategoryId = id
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },
    changeFilterbrand(brand) {
      this.$refs.myList01.load_status_clear()
      this.proSearch.page = 1
      this.proSearch.orderType = ''; this.proSearch.orderWay = ''; this.proSearch.proBrand = brand
      this.proSearch.tagId = ''; this.proSearch.proCategoryId = ''
      this.$nextTick(() => {
        this.proList = []
        this.getProList()
      })
    },
    // 获焦事件
    onFocus() {
      this.$refs.serTopFilter.closePullBox()
      this.$refs.myList01.load_status_clear()
      this.searchValue = ''
      this.proList = []
      this.proSearch.page = 1
    },
    inputSer() {
      this.$refs.serTopFilter.closePullBox()
      this.proList = []
      this.proSearch.page = 1
      this.proSearch.proName = this.searchValue
      this.getProList()
    },
    loadPro(e) { console.log(e) },
    // 加入购物车
    toCart(item) {
      console.log(item)
      this.pid = item.productId
      this.proDetailInfo = item
      this.showSpu = true
      ProductListspu(item.productId).then(res => {
        this.firstLevelTagId = res.data.length > 0 ? res.data[0].firstLevelTagId : null
        this.secondLevelTagId = res.data.length > 0 ? res.data[0].secondLevelTagId : null
        this.$nextTick(() => {
          this.$refs.spuDrawer.changeShow(true)
        })
      })
    },
    addspu(item) {
      console.log('addspu', item)
      this.pid = item.productId
      this.proDetailInfo = item
      this.showSpu = true
      ProductListspu(item.productId).then(res => {
        this.firstLevelTagId = res.data.length > 0 ? res.data[0].firstLevelTagId : null
        this.secondLevelTagId = res.data.length > 0 ? res.data[0].secondLevelTagId : null
        console.log('addspu', this.firstLevelTagId, this.secondLevelTagId)
        this.$nextTick(() => {
          this.$refs.spuDrawer.changeShow(true)
        })
      })
    },
    closePopup() {
      console.log('closePopup')
      this.firstLevelTagId = null
      this.secondLevelTagId = null
      this.showSpu = false
    }
  }
}
</script>

<style lang="scss">
.tagIdProList_top2 {
  width: 10rem;
  height: 3.81rem;
  background: linear-gradient(180deg, #e3eefb 0%, #ffffff00 100%);

  padding-top: 0.27rem;
  .tagIdProList_ser {
    margin-top: 0.37rem;
    .van-search {
      width: 9.25rem;
      height: 0.85rem;
      border-radius: 0.43rem;
      background: #fff;
      border: 0.03rem solid #1084d1;
    }

    .van-search__content {
      background-color: rgba(243, 246, 250, 0);
    }
  }
  .search_filter {
    width: 10rem;
    border-radius: 0.27rem 0.27rem 0 0;
    background: linear-gradient(180deg, #fff 0%, #ffffff00 100%);
    padding-top: 0.32rem;
    margin-top: 0.27rem;
    .tab_category_popup {
      top: 0.8rem;
    }
  }
}
</style>
